/**
 * Admin Audit Hooks
 */

import { useQuery } from '@tanstack/react-query'
import { tokenStorage } from '@/lib/api'
import * as service from './admin-audit.service'
import type { AuditSearchFilters } from './admin-audit.service'

const keys = {
  all: ['admin-audit'] as const,
  search: (filters: AuditSearchFilters) => [...keys.all, 'search', filters] as const,
  securityStats: () => [...keys.all, 'security-stats'] as const,
}

export function useAuditSearch(filters: AuditSearchFilters) {
  const hasToken = !!tokenStorage.getAccessToken()
  return useQuery({
    queryKey: keys.search(filters),
    queryFn: () => service.searchAuditLogs(filters),
    enabled: hasToken,
    staleTime: 30 * 1000,
  })
}

export function useSecurityStats() {
  const hasToken = !!tokenStorage.getAccessToken()
  return useQuery({
    queryKey: keys.securityStats(),
    queryFn: service.getSecurityStats,
    enabled: hasToken,
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  })
}
